import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

import {MethodEditorTab} from '../method-config/MethodConfigConstants';

export interface ProcedureConfirmExitWithUnsavedChangesModalProps {
  onRequestSubmit: () => void;
  onRequestClose: () => void;
  onRequestLeaveWithoutSaving: () => void;
  isEditingMethodTab?: boolean;
  currentMethodEditorTab?: MethodEditorTab;
  anyErrorsInTables: boolean;
}

export default function ProcedureConfirmExitWithUnsavedChangesModal(
  props: ProcedureConfirmExitWithUnsavedChangesModalProps
): JSX.Element {
  const {isEditingMethodTab = false, currentMethodEditorTab} = props;
  const modalBody = `Are you sure you want to leave this page? Changes you have made to this ${
    isEditingMethodTab
      ? `unit operation's ${currentMethodEditorTab === MethodEditorTab.TESTS ? 'tests' : 'definitions'}`
      : 'recipe'
  } will be lost.`;

  return (
    <Modal
      title={`${isEditingMethodTab ? 'Unsubmitted' : 'Unsaved'} changes`}
      flexContent={true}
      buttons={[
        {
          text: `Leave without ${isEditingMethodTab ? 'submitting' : 'saving'}`,
          submit: false,
          style: ButtonStyle.TERTIARY_GRAY,
          onClick: () => {
            props.onRequestLeaveWithoutSaving();
            props.onRequestClose();
          },
        },
        {
          text: `${isEditingMethodTab ? 'Submit' : 'Save'} changes`,
          submit: true,
          style: ButtonStyle.PRIMARY,
          disabled: props.anyErrorsInTables,
          tooltipTitle: props.anyErrorsInTables ? 'Please fix errors in the tables' : undefined,
        },
      ]}
      onRequestSubmit={() => {
        props.onRequestSubmit();
      }}
      onRequestClose={props.onRequestClose}
    >
      <p className={css(styles.modalBody)}>{modalBody}</p>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalBody: {
    fontSize: '14px',
  },
  cancelButton: {
    background: 'transparent',
  },
});
